import { useState } from 'react';
import { useHistory } from 'react-router-dom';

export function useAction() {
    const history = useHistory();
    const [step, setStep] = useState(1);
    const [accessCode, setAccessCode] = useState(null);
    const [ebookTitle, setEbookTitle] = useState('');

    const handleNextStep = (accessCode, ebookTitle) => {
        setAccessCode(accessCode);
        setEbookTitle(ebookTitle)
        setStep(step + 1);
    }

    const handleBackStep = (accessCode, ebookTitle) => {
        setAccessCode(accessCode);
        setEbookTitle(ebookTitle)
        setStep(step - 1);
    }

    return {
        step,
        accessCode,
        ebookTitle,
        handleNextStep,
        handleBackStep
    }
}